/** What a recipient sees for an invitation link. */
export const LINK_STATE = Object.freeze({
  VALID: 'valid',
  /** A valid link, opened while signed in as a different person than the one invited. */
  OTHER_ACCOUNT: 'otherAccount',
  EXPIRED: 'expired',
  USED: 'used',
  INVALID: 'invalid',
});

export { API_INVITATION_STATUS } from '../../../services/invitationsService.js';
